import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/feature/rename/feature.rename.mutation.gql"
import type {
  FeatureRenameMutation,
  FeatureRenameMutationVariables,
} from "@/v2-backoffice-client/feature/rename/__types__/feature.rename.mutation"

type Options = MutationHookOptions<
  FeatureRenameMutation,
  FeatureRenameMutationVariables
>

export function useFeatureRenameMutation(options?: Options) {
  return useMutation<FeatureRenameMutation, FeatureRenameMutationVariables>(
    mutation,
    options,
  )
}
